module.exports = "pegasus_template/assets/three-column-text-preview.png";